<div>
    <img [src]="sectionInfo.imageUrl" alt="Imagen de un centro médico" class="single-cover-image">
    <h1 class="webapp-title">{{sectionInfo.title}}</h1>
    <p>{{sectionInfo.subtitle}}</p>
    <div class="help-center-links">
        <span href="javascript:void(0)" *ngFor="let row of sectionInfo.array;let i = index;" class="link-banner rounded">
            <p class="step-counter">{{i+1}}</p>
            <div class="link-banner-text">
                {{row.text}}
            </div>
        </span>
    </div>
</div>